"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetSeqopService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const debug_consensus_1 = require("@branch-ts/debug-consensus");
const seqop_consensus_1 = require("@branch-ts/seqop-consensus");
const log_consensus_1 = require("@branch-ts/log-consensus");
const web_consensus_1 = require("@branch-ts/web-consensus");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
let VersetSeqopService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetSeqopService = class {
        static { _classThis = this; }
        constructor() {
            this.debug = debug_consensus_1.Debug.instance(this).tag(this.constructor.name, "VersetSeqopService");
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
            });
            this.mediators = new Set();
            this.stores = new Set();
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetSeqopService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        async initialize() {
            const requireLoginService = this.deps.VersetRequireLoginService;
            const store = requireLoginService.unlimitedStorageProvider;
            await store.situations.wait("ready", true);
            seqop_consensus_1.MediatorRegistryMechanism.setStoreProvider((option) => {
                const mediatorStore = new seqop_consensus_1.IndexedDbMediatorStore({
                    mediatorURI: option.uri,
                });
                this.stores.add(mediatorStore);
                return mediatorStore;
            });
            this.debug.log("Register mediator created event listener providing store");
            seqop_consensus_1.MediatorRegistryMechanism.events.of.open.listenBy(this, (option) => {
                const mediator = option.target;
                this.mediators.add(mediator);
                mediator.wait().then(() => {
                    if (mediator.situations.get("destroyed") || !mediator.realm)
                        return;
                    mediator.realm.simulator.events.listenBy(this, "overPendingLimit", () => {
                        log_consensus_1.Logger.error("Mediator over pending limit", { uri: mediator.uri });
                    });
                });
            });
            this.unregisterLogout = web_consensus_1.LogoutMechanism.registerAction("Verset.mediators", async () => {
                seqop_consensus_1.MediatorRegistryMechanism.setStoreProvider(() => null);
                seqop_consensus_1.MediatorRegistryMechanism.events.stopListenBy(this);
                for (const mediator of this.mediators)
                    mediator.destroy();
                this.mediators.clear();
                const results = await Promise.allSettled([...this.stores].map(store => store.dispose()));
                this.stores.clear();
                const failures = results.filter(result => result.status === "rejected");
                if (failures.length)
                    throw new AggregateError(failures.map(result => result.reason), "Could not close mediator stores");
            }, { phase: "cleanup" });
        }
        destroy() {
            this.unregisterLogout?.();
            seqop_consensus_1.MediatorRegistryMechanism.events.stopListenBy(this);
        }
    };
    return VersetSeqopService = _classThis;
})();
exports.VersetSeqopService = VersetSeqopService;
